export const ORDERS_TOP_SLUGS = ["general", "analytics"] as const;

/** Подвкладки «Аналитики»; #analytics без суффикса — первая подвкладка */
export const ORDERS_ANALYTICS_TAB_SLUGS = [
    "analytics-summary",
    "analytics-failed",
    "analytics-speed",
    "analytics-charts",
] as const;

export type OrdersTabs = { topIndex: number; analyticsIndex: number };

const GENERAL: OrdersTabs = { topIndex: 0, analyticsIndex: 0 };
const ANALYTICS_PREFIX = ORDERS_TOP_SLUGS[1];

function analyticsIndex(slug: string): number {
    const idx = ORDERS_ANALYTICS_TAB_SLUGS.indexOf(slug as (typeof ORDERS_ANALYTICS_TAB_SLUGS)[number]);
    return idx >= 0 ? idx : 0;
}

/**
 * Вкладка и подвкладка страницы «Ордера» по hash (#general, #analytics, #analytics-summary, …)
 * или, если hash не распознан, по ?tab=. Без аналитики (фильтр по заявке или статусу) — всегда «Главная».
 * На «Главной» подвкладка аналитики берётся из previous, чтобы возврат на «Аналитику» открыл её же.
 */
export function getOrdersTabsFromHash(hash: string, tabParam: string, hasAnalytics: boolean,
                                      previous: OrdersTabs = GENERAL): OrdersTabs {
    if (!hasAnalytics) {
        return GENERAL;
    }

    const general = { topIndex: 0, analyticsIndex: previous.analyticsIndex };
    const slug = (hash || "").replace("#", "").trim().toLowerCase();
    if (slug === ANALYTICS_PREFIX || slug.startsWith(`${ANALYTICS_PREFIX}-`)) {
        return { topIndex: 1, analyticsIndex: analyticsIndex(slug) };
    }
    if (slug === ORDERS_TOP_SLUGS[0]) {
        return general;
    }

    return (tabParam || "").toLowerCase() === ANALYTICS_PREFIX ? { topIndex: 1, analyticsIndex: 0 } : general;
}
